import { Formik } from 'formik';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stepInfoAboutDamageFulfilled } from '../../../actions/damageReportActions';
import { IStepInfo } from '../../../components/damageReportForm/stepInfo/stepInfo.schema';
import { IDamageReportReducer } from '../../../reducers/damageReportReducer';
import { RootState } from '../../../store';
import { WizardPageProps } from '../../wizard/wizard';
import { IStepInfoAboutDamage, stepInfoAboutDamageSchema } from './stepInfoAboutDamage.schema';
import * as StyledStepInfoAboutDamage from './stepInfoAboutDamage.styles';
import StepInfoAboutDamageForm from './stepInfoAboutDamageForm';

interface Props extends WizardPageProps {}

const StepInfoAboutDamage: FC<Props> = ({ onSubmit }) => {
	const dispatch = useDispatch<any>();
	const damageReportReducer: IDamageReportReducer = useSelector((store: RootState) => store.damageReportReducer);
	const stepInfoAboutDamageInfo: IStepInfoAboutDamage = damageReportReducer.stepInfoAboutDamage;
	const stepInfoValues: IStepInfo = damageReportReducer.stepInfo;

	const StepInfoAboutDamageSubmit = values => {
		dispatch(stepInfoAboutDamageFulfilled(values, stepInfoValues));
		onSubmit(values);
	};
	return (
		<StyledStepInfoAboutDamage.Wrapper>
			<Formik
				initialValues={stepInfoAboutDamageInfo}
				enableReinitialize
				validationSchema={stepInfoAboutDamageSchema}
				onSubmit={StepInfoAboutDamageSubmit}>
				{({ values, setFieldTouched, setFieldValue, isValid, isSubmitting, errors }) => (
					<StepInfoAboutDamageForm
						values={values}
						errors={errors}
						setFieldTouched={setFieldTouched}
						setFieldValue={setFieldValue}
						isValid={isValid}
						isSubmitting={isSubmitting}
					/>
				)}
			</Formik>
		</StyledStepInfoAboutDamage.Wrapper>
	);
};

export default StepInfoAboutDamage;
